import API from './index';

let config = {
  headers: {
    authorization: `bearer ${localStorage.getItem('drillwurks_token')}`
  }
};

//Auth **
export const signIn = authData => {
  //authData.login_type = "web";
  return API.post('/auth/signin', authData);
};

export const forgotPassword = email => {
  return API.post('/auth/forgot-password', { email: email });
};

export const resetPassword = resetDetails => {
  return API.post('/auth/reset-password', resetDetails);
};

export const getNewToken = refreshToken => {
  return API.post('/auth/token', refreshToken);
};

// Dashboard

export const getDashboardJobs = () => {
  return API.get('/dashboard/jobs', config);
};

export const getDashboardDrills = () => {
  return API.get('/dashboard/drills', config);
};

// Items

export const getItems = (
  page,
  limit,
  statusId,
  sortBy,
  location_id,
  container_id,
  q,
  category_id
) => {
  config.params = {
    page: page,
    limit: limit,
    status_id: statusId,
    location_id: location_id,
    container_id: container_id,
    sortBy: sortBy,
    q: q,
    category_id: category_id
  };

  return API.get('/items', config);
};

export const getItem = id => {
  return API.get('/items/' + id, config);
};

export const deleteItem = id => {
  return API.delete('/items/' + id, config);
};

export const createItem = data => {
  return API.post('/items/', data, config);
};

export const archiveItem = (id, stockId) => {
  return API.post(`/items/${id}/stocks/${stockId}/archive`, config);
};

export const patchItem = (id, data) => {
  return API.patch('/items/' + id, data, config);
};

export const getItemStocks = id => {
  return API.get(`/items/${id}/stocks`, config);
};

export const createItemStocks = (id, data) => {
  return API.post(`/items/${id}/individual-stocks`, data, config);
};

export const updateItemQuantity = (id, data) => {
  return API.post(`/items/${id}/stocks`, data, config);
};

export const patchItemStock = (id, stockId, data) => {
  return API.patch(`/items/${id}/stocks/${stockId}`, data, config);
};

export const deleteItemStocks = (itemId, stockId) => {
  return API.delete(`/items/${itemId}/stocks/${stockId}`, config);
};

export const searchItem = (q, page, limit) => {
  config.params = { q: q, page: page, limit: limit };
  return API.get(`/items/search/stocks`, config);
};

export const searchStockByEpc = epc => {
  return API.get(`/items/search/stocks/${epc}`, config);
};

export const patchImage = (id, data) => {
  return API.patch('/items/' + id + '/image', data, config);
};

export const searchItemMetadata = (key, q) => {
  config.params = { key: key, q: q };
  return API.get(`/items/metadata/${key}`, config);
};

export const getStockLogs = (page, limit, sortBy, id, stockId) => {
  config.params = {
    page: page,
    limit: limit,
    sortBy: sortBy,
    id: id,
    stock_id: stockId
  };
  return API.get(`/items/${id}/stocks/${stockId}/logs`, config);
};

export const getItemLogs = (page, limit, sortBy, id, stockId) => {
  config.params = {
    page: page,
    limit: limit,
    sortBy: sortBy,
    id: id,
    stock_id: stockId
  };
  return API.get(`/items/logs/${id}`, config);
};

//Drill types
export const getDrillTypes = (page, limit, sortBy) => {
  config.params = { page: page, limit: limit, sortBy: sortBy };
  return API.get('/drills/meta/types/web', config);
};

export const getDrillType = id => {
  return API.get('/drills/meta/types/web/' + id, config);
};

export const createDrillType = data => {
  return API.post('/drills/meta/types', data, config);
};

export const patchDrillType = (id, data) => {
  return API.patch('/drills/meta/types/web/' + id, data, config);
};

export const deleteDrillType = id => {
  return API.delete('/drills/meta/types/web/' + id, config);
};

export const getDrillMakes = (page, limit, sortBy) => {
  config.params = { page: page, limit: limit, sortBy: sortBy };
  return API.get('/drills/meta/makes/web', config);
};

export const getDrillMake = id => {
  return API.get('/drills/meta/makes/web/' + id, config);
};

export const getAllDrillMakes = () => {
  return API.get('/drills/meta/makes/', config);
};

export const createDrillMake = data => {
  return API.post('/drills/meta/makes', data, config);
};

export const patchDrillMake = (id, data) => {
  return API.patch('/drills/meta/makes/web/' + id, data, config);
};

export const deleteDrillMake = id => {
  return API.delete('/drills/meta/makes/web/' + id, config);
};

export const getDrillModels = (page, limit, sortBy) => {
  config.params = { page: page, limit: limit, sortBy: sortBy };
  return API.get('/drills/meta/models/web', config);
};

export const getDrillModel = id => {
  return API.get('/drills/meta/models/web/' + id, config);
};

export const createDrillModel = data => {
  return API.post('/drills/meta/models', data, config);
};

export const patchDrillModel = (id, data) => {
  return API.patch('/drills/meta/models/web/' + id, data, config);
};

export const deleteDrillModel = id => {
  return API.delete('/drills/meta/models/web/' + id, config);
};

export const getRepairOptions = (page, limit, sortBy) => {
  config.params = { page: page, limit: limit, sortBy: sortBy };
  return API.get('/drills/repair/additional/web', config);
};

export const getAllRepairOptions = () => {
  return API.get('/drills/repair/additional/', config);
};

export const getRepairOption = id => {
  return API.get('/drills/repair/additional/' + id, config);
};

export const createRepairOption = data => {
  return API.post('/drills/repair/additional/new', data, config);
};

export const patchRepairOption = (id, data) => {
  return API.patch('/drills/repair/additional/' + id, data, config);
};

export const deleteRepairOption = id => {
  return API.delete('/drills/repair/additional/' + id, config);
};

export const getRepairCategories = (page, limit, sortBy) => {
  config.params = { page: page, limit: limit, sortBy: sortBy };
  return API.get('/drills/repair/category/web', config);
};

export const getRepairCategory = id => {
  return API.get('/drills/repair/category/' + id, config);
};

export const createRepairCategory = data => {
  return API.post('/drills/repair/category', data, config);
};

export const patchRepairCategory = (id, data) => {
  return API.patch('/drills/repair/category/' + id, data, config);
};

export const deleteRepairCategory = id => {
  return API.delete('/drills/repair/category/' + id, config);
};

//Categories

export const getCategories = (page, limit, sortBy) => {
  config.params = { page: page, limit: limit, sortBy: sortBy };
  return API.get('/categories', config);
};

export const getSubCategories = (page, limit, sortBy) => {
  config.params = { page: page, limit: limit, sortBy: sortBy };
  return API.get('/categories/subcategories', config);
};

export const getSubCategoriesById = (id, page, limit, sortBy) => {
  config.params = { page: page, limit: limit, sortBy: sortBy };
  return API.get(`/categories/${id}/subcategories`, config);
};

export const getCategory = id => {
  return API.get('/categories/' + id, config);
};

export const createCategory = data => {
  return API.post('/categories/', data, config);
};

export const patchCategory = (id, data) => {
  return API.patch('/categories/' + id, data, config);
};

export const deleteCategory = id => {
  return API.delete('/categories/' + id, config);
};

// Containers

export const getContainers = (page, limit, sortBy) => {
  config.params = { page: page, limit: limit, sortBy: sortBy };
  return API.get('/containers', config);
};

export const getContainer = id => {
  return API.get('/containers/' + id, config);
};

export const createContainer = data => {
  return API.post('/containers/', data, config);
};

export const patchContainer = (id, data) => {
  return API.patch('/containers/' + id, data, config);
};

export const deleteContainer = id => {
  return API.delete('/containers/' + id, config);
};

// Locations

export const getLocations = (page, limit, sortBy) => {
  config.params = { page: page, limit: limit, sortBy: sortBy };
  return API.get('/locations', config);
};

export const getLocation = id => {
  return API.get('/locations/' + id, config);
};

export const createLocation = data => {
  return API.post('/locations/', data, config);
};

export const patchLocation = (id, data) => {
  return API.patch('/locations/' + id, data, config);
};

export const deleteLocation = id => {
  return API.delete('/locations/' + id, config);
};

export const getContainerByLocationId = id => {
  return API.get(`/locations/${id}/containers/`, config);
};

// Item Units

export const getItemUnits = () => {
  return API.get('/item-units', config);
};

// User

export const getUsers = (page, limit, sortBy, searchQ = '') => {
  config.params = { page: page, limit: limit, sortBy: sortBy, q: searchQ };

  return API.get('/users', config);
};

export const getUser = id => {
  return API.get('/users/' + id, config);
};

export const createUser = data => {
  return API.post('/users', data, config);
};

export const patchUser = (id, data) => {
  return API.patch('/users/' + id, data, config);
};

export const patchUserPassword = (id, data) => {
  return API.patch(`/users/${id}/password`, data, config);
};

export const patchUserPin = (id, data) => {
  return API.patch(`/users/${id}/login_pin`, data, config);
};

export const deleteUser = id => {
  return API.delete('/users/' + id, config);
};

export const getUseLogs = (id, page, limit, sortBy) => {
  config.params = { page: page, limit: limit, sortBy: sortBy };
  return API.get('/users/' + id + '/logs', config);
};

// Clients

export const getClients = (page, limit, sortBy, searchQ = '') => {
  config.params = { page: page, limit: limit, sortBy: sortBy, q: searchQ };
  return API.get('/clients', config);
};

export const getClientsBySearchQuery = (page, limit, sortBy, searchQ) => {
  config.params = { page: page, limit: limit, sortBy: sortBy, q: searchQ };
  return API.get(`/clients/search/${searchQ}`, config);
};

export const getClientsByZip = zip => {
  return API.get(`/clients/zip/${zip}`, config);
};

export const createClient = data => {
  return API.post('/clients', data, config);
};

export const addClientBulk = data => {
  return API.post('/clients/upload', data, config);
};

export const getClient = id => {
  return API.get('/Clients/' + id, config);
};

export const patchClient = (id, data) => {
  return API.patch('/clients/' + id, data, config);
};

export const deleteClient = id => {
  return API.delete('/clients/' + id, config);
};

export const getClientBarcode = (id, fedexServiceTypeId) => {
  return API.get(`/clients/bulk-print/${id}/${fedexServiceTypeId}`, config);
};

export const getClientLabels = (page, limit, sortBy) => {
  config.params = { page: page, limit: limit, sortBy: sortBy };
  return API.get('/clients/labels/', config);
};

export const getClientShipmentsBySearchQuery = (
  page,
  limit,
  sortBy,
  searchQ
) => {
  config.params = { page: page, limit: limit, sortBy: sortBy, q: searchQ };
  return API.get(`/clients/labels/${searchQ}`, config);
};

export const getTrackingStatus = trackingNr => {
  return API.get(`/clients/tracking/${trackingNr}`, config);
};

// QuickBooks
export const isQbConnected = () => {
  return API.get('/qb/is-connected', config);
};

export const authQb = () => {
  return API.get('/qb/auth', config);
};

export const getQbInvoice = (page, limit, sortBy) => {
  config.params = {
    page: page,
    limit: limit,
    sortBy: sortBy
  };
  return API.get('/drills/qb/invoice', config);
};

export const createInvoice = id => {
  return API.get(`/qb/invoice/${id}`, config);
};

// User Groups
export const getUserGroups = () => {
  return API.get(`users/user-groups`, config);
};

// FedEx Service types
export const getFedexServiceTypes = () => {
  return API.get(`fedex/service-types`, config);
};

// Orders

export const getOrders = (page, limit, sortBy, fromDate, toDate) => {
  config.params = {
    page: page,
    limit: limit,
    sortBy: sortBy,
    from_date: fromDate,
    to_date: toDate
  };
  return API.get('/orders', config);
};

export const createOrder = data => {
  return API.post('/orders', data, config);
};

// Inventory

export const getInventory = (
  page,
  limit,
  status,
  sortBy,
  q,
  category_id,
  location_id,
  container_id
) => {
  config.params = {
    page: page,
    limit: limit,
    status_id: status,
    sortBy: sortBy,
    q: q,
    category_id: category_id,
    location_id: location_id,
    container_id: container_id
  };
  console.log(config);
  return API.get('/inventory/', config);
};

export const getNonTrackingInventory = (
  page,
  limit,
  status,
  sortBy,
  q,
  category_id
) => {
  config.params = {
    page: page,
    limit: limit,
    status_id: status,
    sortBy: sortBy,
    q: q,
    category_id: category_id
  };
  console.log(config);
  return API.get('/inventory/non-tracking/', config);
};

export const getInventoryLogs = (page, limit, from_data, to_data, sortBy) => {
  config.params = {
    page: page,
    limit: limit,
    from_date: from_data,
    to_date: to_data,
    sortBy: sortBy
  };
  return API.get('/inventory/logs', config);
};

export const getInventoryLogDetails = (id, page, limit, status, sortBy) => {
  config.params = {
    page: page,
    limit: limit,
    status: status,
    sortBy: sortBy
  };
  return API.get('/inventory/logs/' + id, config);
};

export const getArchived = (page, limit, sortBy) => {
  config.params = {
    page: page,
    limit: limit,
    sortBy: sortBy
  };
  return API.get('/inventory/archived', config);
};

// User Roles

export const getUserRoles = () => {
  return API.get('/roles', config);
};

// User Groups

// export const getUserGroups = (page, limit, sortBy) => {
//   config.params = { page: page, limit: limit, sortBy: sortBy };
//   return API.get('/groups', config);
// };

export const getUserGroup = id => {
  return API.get('/groups/' + id, config);
};

export const createUserGroup = data => {
  return API.post('/groups/', data, config);
};

export const patchUserGroup = (id, data) => {
  return API.patch('/groups/' + id, data, config);
};

export const deleteUserGroup = id => {
  return API.delete('/groups/' + id, config);
};

// Me
export const signOut = data => {
  return API.post('/me/logout', data, config);
};

export const patchPassword = data => {
  return API.patch('/me/password', data, config);
};

export const getUserProfile = () => {
  return API.get('/me', config);
};

// Reports
export const getNotReturnedWeapons = (page, limit, sortBy, q) => {
  config.params = { page: page, limit: limit, sortBy: sortBy, q: q };
  return API.get('/items/stocks/not_returned', config);
};

export const getDischarged = (page, limit, sortBy, q, from_date, to_date) => {
  config.params = {
    page: page,
    limit: limit,
    sortBy: sortBy,
    q: q,
    from_date: from_date,
    to_date: to_date
  };
  return API.get('/items/discharged', config);
};

export const getCheckInCheckOutLogs = (
  page,
  limit,
  sortBy,
  statusId,
  from_date,
  to_date
) => {
  config.params = {
    page: page,
    limit: limit,
    sortBy: sortBy,
    status_id: statusId,
    from_date: from_date,
    to_date: to_date
  };
  return API.get('/items/logs', config);
};

export const getCheckInCheckOutLogsDetails = (
  id,
  page,
  limit,
  status,
  sortBy
) => {
  config.params = {
    page: page,
    limit: limit,
    status: status,
    sortBy: sortBy
  };
  return API.get('/items/logs/' + id, config);
};

// Readers
export const getUnauthorizedAccessLogs = (
  page,
  limit,
  sortBy,
  statusId,
  from_date,
  to_date
) => {
  config.params = {
    page: page,
    limit: limit,
    sortBy: sortBy,
    status_id: statusId,
    from_date: from_date,
    to_date: to_date
  };
  return API.get('/readers/logs', config);
};

export const getReaders = (page, limit, sortBy) => {
  config.params = { page: page, limit: limit, sortBy: sortBy };
  return API.get('/readers', config);
};

export const getReader = id => {
  return API.get(`/readers/${id}`, config);
};

export const patchReader = (id, data) => {
  return API.patch(`/readers/${id}`, data, config);
};

export const deleteReaderLogs = () => {
  return API.delete(`/readers/logs`, config);
};
